import { parseUserMessageSlashCommand } from "@/src/utils/chatUtils/parseUserMessageSlashCommand";

export type UserMessageQuestionContentProps = {
  content: string;
};

/** 用户气泡正文：识别 `/command 正文` 并将 command 高亮为品牌色 */
export function UserMessageQuestionContent({
  content,
}: UserMessageQuestionContentProps) {
  const slashParts = parseUserMessageSlashCommand(content);

  if (!slashParts) {
    return <>{content}</>;
  }

  return (
    <>
      {/* 处理/advisor-proposal-review 统一给用户不展示，交互变为发送的时候更新 content */}
      {/* <span className="text-content_brand_tertiary">{slashParts.command}</span> */}
      {slashParts.rest}
    </>
  );
}
